export enum DNGCalibrationIlluminant {
	Unknown = 0,
	Daylight = 1,
	Fluorescent = 2,
	Tungsten = 3,
	Flash = 4,
	FineWeather = 9,
	CloudyWeather = 10,
	Shade = 11,
	DaylightFluorescent = 12,
	DayWhiteFluorescent = 13,
	CoolWhiteFluorescent = 14,
	WhiteFluorescent = 15,
	WarmWhiteFluorescent = 16,
	StandardLightA = 17,
	StandardLightB = 18,
	StandardLightC = 19,
	D55 = 20,
	D65 = 21,
	D75 = 22,
	D50 = 23,
	ISOStudioTungsten = 24,
	OtherLightSource = 25,
}

/** Convert an EXIF CalibrationIlluminant enum value to a colour temperature in Kelvin. Returns 0 for unknown. */
export function illuminantToTemperature(illuminant: number): number {
	switch (illuminant) {
		case DNGCalibrationIlluminant.Daylight:
			return 5500.0
		case DNGCalibrationIlluminant.Fluorescent:
			return (3800.0 + 4500.0) * 0.5
		case DNGCalibrationIlluminant.Tungsten:
			return 2850.0
		case DNGCalibrationIlluminant.Flash:
			return 5500.0
		case DNGCalibrationIlluminant.FineWeather:
			return 5500.0
		case DNGCalibrationIlluminant.CloudyWeather:
			return 6500.0
		case DNGCalibrationIlluminant.Shade:
			return 7500.0
		case DNGCalibrationIlluminant.DaylightFluorescent:
			return (5700.0 + 7100.0) * 0.5
		case DNGCalibrationIlluminant.DayWhiteFluorescent:
			return (4600.0 + 5500.0) * 0.5
		case DNGCalibrationIlluminant.CoolWhiteFluorescent:
			return (3800.0 + 4500.0) * 0.5
		case DNGCalibrationIlluminant.WhiteFluorescent:
			return (3250.0 + 3800.0) * 0.5
		case DNGCalibrationIlluminant.WarmWhiteFluorescent:
			return (2600.0 + 3250.0) * 0.5
		case DNGCalibrationIlluminant.StandardLightA:
			return 2850.0
		case DNGCalibrationIlluminant.StandardLightB:
			return 5500.0
		case DNGCalibrationIlluminant.StandardLightC:
			return 6500.0
		case DNGCalibrationIlluminant.D55:
			return 5500.0
		case DNGCalibrationIlluminant.D65:
			return 6500.0
		case DNGCalibrationIlluminant.D75:
			return 7500.0
		case DNGCalibrationIlluminant.D50:
			return 5000.0
		case DNGCalibrationIlluminant.ISOStudioTungsten:
			return 3200.0
		default:
			return 0.0
	}
}
